import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import LocationFill from '@icons/LocationFill';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

function Shop() {
    const { shopName } = useCalculatedRequest();
    const { t } = useTranslation('order');
    return (
        <Row className={styles.container} >
            <LocationFill color={colors.gray6}
                style={{ marginRight: 4 }}/>
            <TextUnderline>
                <Text size='lg' fontWeight='bold'>{shopName}</Text>
            </TextUnderline>
            <Text size='lg'>{t('shop.orderFrom')}</Text>
        </Row>
    );
}

export default Shop;
